<div class="p-dialog-media__cnt">
    <p>my-gallery works!</p>
</div>
